"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var AttachmentPreview_1 = require("./AttachmentPreview");
var useNormalizedUploads_1 = require("./useNormalizedUploads");
var utils_1 = require("utils");
var DropTarget_1 = require("./DropTarget");
var react_1 = require("react");
var ATTACHMENTS_STYLES = "flex flex-grow flex-col my-auto mx-0 p-0";
var INACTIVE_STYLES = "border-contentAreaBorder";
var CONTAINER_STYLES = "flex border content-center w-full";
var ACTIVE_STYLES = "border-actionable";
var ERROR_STYLES = "text-error font-body text-xs font-semibold text-center w-full mt-2";
var minHeight = (0, utils_1.remCalc)(50);
var AttachmentList = function (_a) {
    var _b;
    var accept = _a.accept, onUpdate = _a.onUpdate, _c = _a.previews, previews = _c === void 0 ? [] : _c, getEndpointsForFilenames = _a.getEndpointsForFilenames, maxFiles = _a.maxFiles, onDelete = _a.onDelete, onUpload = _a.onUpload, onError = _a.onError, label = _a.label;
    var _d = (0, useNormalizedUploads_1.useNormalizedUploads)({
        previews: previews,
        onUpdate: onUpdate,
        accept: accept,
        onDelete: onDelete,
        getEndpointsForFilenames: getEndpointsForFilenames,
        onUpload: onUpload,
        maxFiles: maxFiles,
        onError: onError,
    }), dropzone = _d.dropzone, renderablePreviews = _d.renderablePreviews, uploads = __rest(_d, ["dropzone", "renderablePreviews"]);
    (0, react_1.useEffect)(function () {
        dropzone.fileRejections.map(function (r) {
            onError === null || onError === void 0 ? void 0 : onError(new Error(r.file.name + " is not an acceptable file type."));
        });
    }, [dropzone.fileRejections]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "rounded bg-white border border-lochivar-dark p-2 flex-col w-full" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({}, dropzone.getRootProps(), { className: (0, utils_1.concatStyles)([
                    CONTAINER_STYLES,
                    dropzone.isDragActive ? ACTIVE_STYLES : INACTIVE_STYLES,
                ]), style: { minHeight: minHeight } }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({}, dropzone.getInputProps()), void 0), renderablePreviews.length > 0 ? ((0, jsx_runtime_1.jsx)("ul", __assign({ className: ATTACHMENTS_STYLES, style: { minHeight: minHeight } }, { children: renderablePreviews.map(function (preview, index) {
                            return ((0, jsx_runtime_1.jsx)(AttachmentPreview_1.AttachmentPreview, { onSort: uploads.handleSort, preview: preview, onDelete: uploads.handleDeletedFile, index: index, id: preview.id, progress: uploads.progressForUpload(preview.id), onFinishSort: uploads.handleFinishSort }, preview.id));
                        }) }), void 0)) : ((0, jsx_runtime_1.jsx)(DropTarget_1.DropTarget, { label: label, active: dropzone.isDragActive }, void 0))] }), void 0), (_b = dropzone.fileRejections) === null || _b === void 0 ? void 0 : _b.map(function (rej) { return ((0, jsx_runtime_1.jsxs)("p", __assign({ className: ERROR_STYLES }, { children: [rej.file.name, " was not accepted."] }), void 0)); })] }), void 0));
};
exports.AttachmentList = AttachmentList;
